import Button from '@/components/Button';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import OutlinedInput from '@mui/material/OutlinedInput';
import { CheckOutlined, CollapseArrowDownOutlined } from '@zeelool/icon';
import { useTranslations } from 'next-intl';
import { useEffect, useRef, useState } from 'react';
import CouponListPc from './CouponList.pc';

interface EntrancePcProps {
  canUseLength: number;
  couponCode: string;
  checkCoupon: boolean;
  couponCodeText: string;
  onChangeCouponCode: (code: string) => void;
  applyLoading: boolean;
  handleCodeApply: () => void;
  handleCodeCancel: () => void;
  usableCouponList: any[];
  handleCouponApply: (item: any) => void;
}

export default function EntrancePc(props: EntrancePcProps) {
  const t = useTranslations('coupons');
  const {
    canUseLength,
    couponCode,
    checkCoupon,
    couponCodeText,
    onChangeCouponCode,
    applyLoading,
    handleCodeApply,
    handleCodeCancel,
    usableCouponList,
    handleCouponApply,
  } = props;

  const couponInputRef = useRef<HTMLInputElement>(null);
  const couponListRef = useRef<any>(null);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const [couponOpened, setCouponOpened] = useState(false);

  useEffect(() => {
    if (couponOpened) {
      setAnchorEl(couponInputRef.current);
    } else {
      setAnchorEl(null);
    }
  }, [couponOpened]);

  const handleCodeStatus = () => {
    setCouponOpened(false);
    if (checkCoupon) {
      handleCodeCancel();
    } else {
      handleCodeApply();
    }
  };

  return (
    <div>
      <div className="flex justify-between items-center mb-12">
        <h3 className="text-[18px] font-bb">
          {t('Code')} / {t('Coupon')}
        </h3>
        <span className="notranslate text-sm text-auxiliary-text">
          ({canUseLength > 1 ? t('availableCoupons') : t('availableCoupon')}: {canUseLength})
        </span>
      </div>

      {/* input */}
      <ClickAwayListener onClickAway={() => setCouponOpened(false)}>
        <div className="flex h-[46px]">
          <OutlinedInput
            inputRef={couponInputRef}
            className="w-full !pr-0"
            placeholder={t('enterOrSelectCodeOrCoupon')}
            value={couponCodeText || couponCode}
            // 禁止输入 但可以点击
            inputProps={{
              readOnly: checkCoupon,
            }}
            onChange={(e) => {
              setCouponOpened(false);
              onChangeCouponCode(e.target.value);
            }}
            onFocus={() => {
              if (checkCoupon) {
                return;
              }
              setCouponOpened(true);
            }}
            startAdornment={
              checkCoupon && (
                <div className="flex items-center justify-center ">
                  <CheckOutlined className="text-[#85c05d] text-[28px] font-bold " />
                </div>
              )
            }
            endAdornment={
              !checkCoupon && (
                <div
                  className="flex items-center justify-center w-[46px] h-[46px] absolute right-0 top-0 cursor-pointer"
                  onClick={() => {
                    if (checkCoupon) {
                      return;
                    }
                    if (couponOpened) {
                      setCouponOpened(false);
                      setAnchorEl(null);
                    } else {
                      setCouponOpened(true);
                      setAnchorEl(couponInputRef.current);
                    }
                  }}
                >
                  <CollapseArrowDownOutlined
                    className={`${couponOpened ? 'rotate-180' : ''} transition-all duration-100`}
                  />
                </div>
              )
            }
            sx={{
              borderTopRightRadius: '0px',
              borderBottomRightRadius: '0px',
              height: '46px',
              backgroundColor: checkCoupon ? '#f4f6f8' : '#fff',
              '& .MuiInputBase-input': {
                fontSize: checkCoupon ? '12px' : '14px',
                color: checkCoupon ? '#282828' : '#606266',
                paddingLeft: '8px',
              },
            }}
          />
          <Button
            variant="contained"
            color="primary"
            onClick={handleCodeStatus}
            loading={applyLoading}
            sx={{
              // 左上角和右下角无圆角
              borderTopLeftRadius: '0px',
              borderBottomLeftRadius: '0px',
              width: '25%',
            }}
          >
            {checkCoupon ? t('Cancel') : t('Apply')}
          </Button>
        </div>
      </ClickAwayListener>

      {/* list */}
      <CouponListPc
        ref={couponListRef}
        couponOpened={couponOpened}
        anchorEl={anchorEl}
        usableCouponList={usableCouponList}
        handleCouponApply={(item: any) => {
          setCouponOpened(false);
          handleCouponApply(item);
        }}
      />
    </div>
  );
}
